import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// Actions
import { gamesActions, gameActions } from '../../actions';

import Header from '../../components/Header';
import List from '../../components/List';

const GamesPage = () => {
  // Hooks
  const dispatch = useDispatch();
  const games = useSelector((state) => state.games);
  const { t } = useTranslation();

  // Effects
  useEffect(() => {
    dispatch(gameActions.setData(null));
    dispatch(gamesActions.fetchGames());
  }, [dispatch]);

  // Methods
  const deleteGame = (item) => {
    dispatch(gamesActions.removeGame(item));
  };

  // Logic
  const items = games.map((i) => ({
    instructor: i.instructor ? i.instructor.email : '',
    // Custom className for status
    rowClass: i.status === 'deleted' ? 'opacity-50 table-light' : '',
    name: {
      label: (
        <Link
          to={
            i.status === 'saved'
              ? '/games/' + i._id
              : '/games/' + i._id + '/players'
          }
          className='text-decoration-none'>
          {i.name}
        </Link>
      ),
      value: i.name.trim().toUpperCase(),
    },
    status: <span className='text-capitalize'>{t(i.status)}</span>,
    num_players: i.players.length,
    created_at: moment(i.created_at).format('MMMM Do YYYY, h:mm:ss a'),
    actions: (
      <span className='text-nowrap'>
        {i.status === 'saved' ? (
          <Link
            key={`edit-${i._id}`}
            to={'/games/' + i._id}
            className='btn w-75 btn-sm btn-outline-primary'>
            {t('Add Players')}
          </Link>
        ) : (
          <Link
            key={`edit-${i._id}`}
            to={'/games/' + i._id + '/players'}
            className='btn w-75 btn-sm btn-outline-success'>
            {t('In Progress')}
          </Link>
        )}
        <button
          key={`remove-${i._id}`}
          disabled={i.status === 'deleted'}
          className={`btn btn-sm btn-light text-danger ms-3 ${
            i.status === 'deleted' ? 'disabled' : ''
          }`}
          onClick={() => deleteGame(i)}>
          <FontAwesomeIcon
            icon='trash-alt'
            size='1x'
            style={{ cursor: 'pointer' }}
          />
        </button>
      </span>
    ),
  }));

  return (
    <div>
      <Header />

      <h2 className='sec-title mt-3 fs-3'>
        <span className='ms-1'>{t('Games')}</span>
      </h2>

      <div>
        <List
          labels={[
            t('Name'),
            t('Instructor'),
            t('Status'),
            t('Players'),
            t('Created At'),
            t('Actions'),
          ]}
          fields={[
            'name',
            'instructor',
            'status',
            'num_players',
            'created_at',
            'actions',
          ]}
          sortables={[
            'name',
            'instructor',
            'status',
            'num_players',
            'created_at',
          ]}
          data={items}
        />
      </div>
    </div>
  );
};

export { GamesPage };
